



































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";
import { Patient } from "../../../../../domain/patient";
import { ExternalImageItem } from "../../../../../domain/externalImage";
import ExternalImageThumbnail from "./externalImage/ExternalImageThumbnail.vue";
import ExternalImageFinder from "./externalImage/ExternalImageFinder.vue";
import ExternalImagePreview from "./externalImage/ExternalImagePreview.vue";

@Component({
  components: {
    ExternalImageThumbnail,
    ExternalImageFinder,
    ExternalImagePreview,
  }
})
export default class ExternalImageTool extends Mixins() {
  data(): any {
    return {
      foundItems: [],
      currentPage: 1,
      selectedItem: null as ExternalImageItem,
      isFinding: false,
      selectedItemIndex: null as number,
    };
  }
  foundItems: ExternalImageItem[];
  currentPage: number;
  selectedItem: ExternalImageItem;
  isFinding: boolean;
  selectedItemIndex: number;

  // 最後に選択した画像エリアにClaio画像を貼り付ける用途がある場合は使用する
  // その用途が無い場合は不要
  @Prop()
  source: IDrawableItemEditable;

  @Prop()
  patient: Patient;

  @Prop({ default: true })
  isPastable: boolean;

  @Watch("foundItems")
  onFoundItemsUpdated(): void {
    this.currentPage = 1;
    this.selectedItem = null;
    this.selectedItemIndex = null;
  }

  @Watch("currentPage")
  onCurrentPageChanged(): void {
    this.selectedItemIndex = this.selectedItem
      ? this.displayItems.indexOf(this.selectedItem)
      : null;
  }

  get displayItems(): ExternalImageItem[] {
    return this.foundItems.slice(this.imageCountPerPage * (this.currentPage - 1), this.imageCountPerPage * this.currentPage);
  }

  get imageCountPerPage(): number {
    return this.$configuration.behavior.document.editor.contents.externalImage.displayCountPerPage;
  }

  thumbnailSelected(selected: ExternalImageItem, index: number): void {
    this.selectedItem = selected;
    this.selectedItemIndex = index;    
  }

  resetScrollPosition(): void {
    // ページ遷移が起こった時にスクロールを初期位置に戻す
    const container = this.$refs.container as HTMLDivElement;
    if (!container) { return; }
    container.scrollTop = 0;
    container.scrollLeft = 0;
  }
}
